module.exports = __webpack_public_path__ + "img/classify-item1.7993c4a8.png";